import React from 'react';
import classNames from 'classnames';

import {
  withSettings,
  IWithSettingsProps,
} from '../../../../../components/context/settings';

import { IndexLink } from '../../../../../components/nav';
import TagIcon from '../../../../../components/ui/icons/TagIcon';

import getStyles from './EpisodeKeywords.styles';
import styles from './EpisodeKeywords.scss';
import {
  IWithI18nProps,
  withI18n,
} from '../../../../../components/context/i18n';
import compose from '../../../../../lib/utils/compose';

interface IEpisodeKeywordsProps extends IWithSettingsProps, IWithI18nProps {
  keywords: string[];
}

function EpisodeKeywords({ keywords, settings, t }: IEpisodeKeywordsProps) {
  const dynamicStyles = getStyles({
    colors: settings.colors.episode,
    fonts: settings.fonts.episode,
  });

  return (
    <div
      data-hook="episode.body.keywords"
      className={classNames(styles.keywords, dynamicStyles.keywords)}
    >
      <TagIcon className={styles.keywordsIcon} />
      &nbsp;
      <ul
        aria-label={t('pages.episode.keywords')}
        className={styles.keywordsList}
      >
        {keywords.map((keyword, index) => (
          <li key={keyword} className={styles.keywordsListItem}>
            <IndexLink
              query={encodeURIComponent('#' + keyword.toLowerCase())}
              onClick={() => {
                // TODO: add bi
              }}
              className={classNames(
                styles.keywordsKeyword,
                dynamicStyles.keywordsKeyword,
              )}
            >
              #{keyword}
            </IndexLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default compose(withI18n, withSettings)(EpisodeKeywords);
